
import { IonIcon, IonItem, IonItemDivider, IonLabel, IonList, IonText } from '@ionic/react'
import { lockOpen, lockOpenOutline } from 'ionicons/icons'
import React from 'react'
import Page from '../components/Page'
import { Capacitor } from '@capacitor/core'

export default class extends React.Component {
  
  render() {
    return (
      <Page title="Grenzwerte" large>
        <IonList>

          <IonItem routerLink="/uebersichtstabellen/schadstoffgrenzwerte">
            <IonLabel className="ion-text-wrap" >
              <h2>Schadstoffgrenzwerte</h2>
              <p>Tabellen mit Grenzwerten von Schadstoffen</p>
            </IonLabel>
          </IonItem>
          
{/* 
          <IonItem routerLink="/uebersichtstabellen/einbautiefen">
            <IonLabel className="ion-text-wrap" >
              <h2>Bauen im Grundwasser</h2>
              <p>Vorschriften pro Kanton</p>
            </IonLabel>
          </IonItem> */}

        </IonList>
      </Page>
    )
  }

}
